import { render } from "./user-mfa.vue?vue&type=template&id=1e5546a2&scoped=true"
import script from "./user-mfa.vue?vue&type=script&lang=js"
export * from "./user-mfa.vue?vue&type=script&lang=js"

import "./user-mfa.vue?vue&type=style&index=0&id=1e5546a2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5546a2"]])

export default __exports__